<template>
  <el-form
    class="source-form"
    :model="formSource"
    :rules="rules"
    ref="ruleFormAddCount"
    label-width="160px"
    :disabled="!edit"
  >
    <el-form-item label="认证源名称" prop="name">
      <el-input
        v-model.trim="formSource.name"
        placeholder="请输入认证源名称"
        disabled
      ></el-input>
    </el-form-item>
    <el-form-item label="是否启用" prop="enabled">
      <el-switch v-model="formSource.enabled"></el-switch>
    </el-form-item>
    <el-form-item label="AppID" prop="clientId">
      <el-input
        v-model.trim="formSource.clientId"
        placeholder="请输入AppID"
      ></el-input>
      <p class="label-tips">
        {{formSource.providerId == 'wechat_open' ? '微信开放' : formSource.providerId == 'wechat_mp' ? '微信公众' : '微博开放'}}平台申请获取的AppID
      </p>
    </el-form-item>
    <el-form-item label="AppSecret" prop="secret">
      <el-input
        v-model.trim="formSource.secret"
        placeholder="请输入AppSecret"
      ></el-input>
      <p class="label-tips">
        {{formSource.providerId == 'wechat_open' ? '微信开放' : formSource.providerId == 'wechat_mp' ? '微信公众' : '微博开放'}}平台申请获取的AppSecret
      </p>
    </el-form-item>
    <el-form-item :label="`${formSource.providerId == 'wechat_open' ? '微信' : formSource.providerId == 'wechat_mp' ? '微信' : '微博'}授权域`" prop="wxip">
      <el-input
        v-model.trim="formSource.wxip"
        placeholder="企业的IDaaS登录地址"
        @input="change($event)"
        :disabled="!add"
      ></el-input>
      <p class="label-tips">
        需要回填至{{formSource.providerId == 'wechat_open' ? '微信开放' : formSource.providerId == 'wechat_mp' ? '微信公众' : '微博开放'}}平台的回调授权域
      </p>
    </el-form-item>
    <el-form-item label="账户关联设置" class="contact-rule" prop="createMethod">
      <template>
        <el-radio v-model="formSource.createMethod" label="1">手动关联IDaaS账户</el-radio>
        <el-radio v-model="formSource.createMethod" label="0">自动创建IDaaS账户</el-radio>
      </template>
    </el-form-item>
    <el-form-item>
      <div v-show="edit" class="footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="handleCancel">取 消</el-button>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import APIS from "@/apis/certificationSource.js"
let wxip = ''
export default {
  props: {
    formSource: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: true
    },
    add: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 检验wxip
    var checkWx = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      console.log(wxip, value)
      if (wxip == "") {
        callback(new Error(`请输入${this.formSource.providerId == 'wechat_open' ? '微信' : this.formSource.providerId == 'wechat_mp' ? '微信公众平台' : '微博'}授权域`))
      } else {
        callback()
      }
    }
    return {
      realmName: this.$realm,
      rules: {
        name: [
          { required: false, message: "请输入认证源名称", trigger: "blur" }
        ],
        enabled: [
          { required: false, message: "请输入组名称", trigger: "blur" }
        ],
        clientId: [
          { required: true, message: "请输入AppID", trigger: "blur" }
        ],
        agentId: [
          { required: true, message: "请输入AgentID", trigger: "blur" }
        ],
        secret: [{ required: true, message: "请输入AppSecret", trigger: "blur" }],
        wxip: [
          { required: true, validator: checkWx, trigger: ["blur", 'change'] }
          // { required: true, message: "请输入微信授权域", trigger: "blur" }
        ],
        createMethod:[
          { required: true, message: "请选择关联规则", trigger: "blur" }
        ]
      }
    }
  },
  created() {
    wxip = this.formSource.wxip
  },
  methods: {
    change(e) {
      wxip = e
      this.$forceUpdate()
    },
    resetForm() {
      this.$refs["ruleFormAddCount"].resetFields()
    },
    validateForm() {
      let validate = false
      this.$refs["ruleFormAddCount"].validate((valid) => {
        if (valid) {
          validate = true
        }
      })
      return validate
    },
    handleCancel() {
      this.$refs["ruleFormAddCount"].resetFields()
      if (!this.add) {
        this.$emit("changeStatus", true)
      } else {
        this.$router.back(-1)
      }
    },
    submitForm() {
      this.addProvider()
    },
    // 获取认证源基本信息
    async addProvider() {
      if (!this.validateForm()) {
        return false
      }
      let params = this.formSource,
        poxName = "addProvider"
      if (!this.add) {
        poxName = "editProvider"
        params.secret == "******" ? (params.secret = null) : ""
      }
      let { status } = await APIS[poxName](
        this.realmName,
        {
          data: params
        },
        this.formSource.providerId
      )
      if (status === 0) {
        if (this.add) {
          this.$router.push({
            path: `/certificationSource`
          })
        } else {
          this.$emit("changeStatus")
        }
      } else {
        if (!this.add) {
          this.$emit("changeStatus", true)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.source-form {
  width: 515px;
  .contact-rule {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
      p {
        width: 150%;
      }
      label {
        margin: 5px 0;
        margin-left: 0px;
      }
    }
  }
}
</style>